// extracted by mini-css-extract-plugin
export default {"privacyContainer":"Privacy_privacyContainer__blbsU","privacyTitle":"Privacy_privacyTitle__FFuBE","link":"Privacy_link__XJKZx"};